export default {
  goodType: 'Good type',
  packing: 'Packing',
  packageCount: 'Package count',
  region: 'Region',
  street: 'Street',
  receiver: 'Receiver',
  addNewReciever: 'Add new reciever',
  personalityId: 'Personality id',
  nationalId: 'National id',
  nationalId: 'کدملی',
  recieverAddress: 'Reciever address',
  recieverPhone: 'Reciever phone',
  recieverMobile: 'Reciever mobile',
  recieverName: 'Reciever name',
  recieverNationalId: 'Reciever national id',
  recieverRegionId: 'Reciever region',
  recieverPersonalityId: 'Reciever personality id',
  recieverStreetId: 'Reciever street',
  recieverZipCode: 'Reciever zip code',
  trackingCode: 'tracking code',
  trackingId: 'tracking Id'
}
